module.exports = __webpack_public_path__ + "static/media/oven-fig-toasts.f9269dee.jpg";